import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import { useEffect, useMemo } from 'react';
import useResolveCurrentOrg from './useResolveCurrentOrg';

export function useCurrentOrgInviteFetching() {
    const { organizationId } = useResolveCurrentOrg();
    const {
        invites: orgInvites,
        invitesRef,
        loadInvites,
        loadingData,
        loadingDataRef,
        handleLoadingDataChange,
    } = OrganizationContainer.useContainer();

    const invites = useMemo(() => {
        if (!organizationId || loadingDataRef.current.invites == true) return null;
        return invitesRef.current.find((org) => org.organizationId === organizationId)?.invites ?? [];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId, orgInvites]);

    useEffect(() => {
        async function fetchInvites() {
            if (!organizationId || loadingDataRef.current.invites == true) return;
            handleLoadingDataChange('invites', true);
            if (invitesRef.current.find((org) => org.organizationId === organizationId)?.invites) {
                handleLoadingDataChange('invites', false);
                return;
            }

            try {
                const result = await loadInvites(organizationId);
                if (result?.resultType !== 'Ok') {
                    console.error('Failed to load invites for organization:', organizationId);
                }
            } catch (error) {
                console.error('Error loading invites.');
            } finally {
                handleLoadingDataChange('invites', false);
            }
        }

        fetchInvites();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    return { invites, isLoading: loadingData.invites };
}
